import React from "react";
import '../css/Responsive.css';
import '../css/App.css';

export default function Footer(){
    return(
        <div className="foot">
            <p>all rights are reserved @aysncdevelopers 2021</p>
            <a href="#">privacy</a>
            <a href="#">terms</a>
        </div>
    )
}